import { render, staticRenderFns } from "./TabColAnno.vue?vue&type=template&id=8582610a&scoped=true&"
import script from "./TabColAnno.vue?vue&type=script&lang=js&"
export * from "./TabColAnno.vue?vue&type=script&lang=js&"
import style0 from "./TabColAnno.vue?vue&type=style&index=0&id=8582610a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8582610a",
  null
  
)

export default component.exports